module.exports = __webpack_public_path__ + "static/media/icon-opening.f9e0f9d2.svg";